export default __webpack_public_path__ + "static/media/instrucciones-1.505e0a31.jpg";